import { gql } from 'graphql-request'

export const GET_GAME_ENABLED_FIRST = gql`
  query GET_GAME_ENABLED_FIRST {
    getGameEnabledFirst {
      error
      status
      data {
        createdAt
        dateLastActive
        dateLastDelete
        enableGameBoxRoom
        enableGameLuckCoin
        enableGameLuckGiftBox
        enableGameLuckNumber
        enableGameGoldMiner
        enableRocketGame
        id
        name
        updatedAt
      }
    }
  }
`
